import * as React from "react";
import { Spin } from "antd";

const Loader = ({
  children,
  loading = false
}: {
  children: any;
  loading: boolean;
}) => <Spin spinning={loading}>{children}</Spin>;

export default Loader;
